module.exports = __webpack_public_path__ + "static/media/about-fusion-plus.6e3862b9.svg";